import { render } from "./blogs-tags-modal.vue?vue&type=template&id=14f220ae"
import script from "./blogs-tags-modal.vue?vue&type=script&lang=js"
export * from "./blogs-tags-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__